import { Plan } from "@jugl-web/rest-api";
import { comparePlanTiers } from "@web-src/modules/cx/pages/CXPlansPage/utils/planTierUtils";

export const getPlanSeatLimit = (plan: Plan): number =>
  plan.default_addons?.find((a) => a.id === "jugl::users")?.credits ?? 1;

export const isDowngradeBlocked = ({
  plan,
  currentPlan,
  entityUserCount,
  isSubscriptionCanceled,
}: {
  plan: Plan;
  currentPlan?: Plan;
  entityUserCount: number;
  isSubscriptionCanceled?: boolean;
}): boolean => {
  const comparison =
    currentPlan && currentPlan.id !== plan.id
      ? comparePlanTiers(currentPlan, plan)
      : undefined;
  return (
    (comparison === "downgrade" || !!isSubscriptionCanceled) &&
    entityUserCount > getPlanSeatLimit(plan)
  );
};
